module.exports = __webpack_public_path__ + "media/icons/star-1b3b4e98.svg";